var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['wac-cms-text-media-list', ("wac-background-" + _vm.background)]},[_c('wac-layout',[_vm._t("items")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }